import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Routes } from "../../../routes";
import { useParams } from "react-router-dom";

import FormPermissions from './FormPermissions'
import FormLoader from './FormLoader'


const Component = () => {
    let { _id } = useParams();
    return (
        <>
            <div className="d-lg-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="mb-4 mb-lg-0">
                    <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
                        <Breadcrumb.Item href={Routes.Dashboard.path}><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
                        <Breadcrumb.Item href={Routes.Members.path}>Members</Breadcrumb.Item>
                        <Breadcrumb.Item href={Routes.Member.path.replace(':_id', _id)}>Member</Breadcrumb.Item>
                        <Breadcrumb.Item active>Edit</Breadcrumb.Item>
                    </Breadcrumb>
                    <h4>Member Profile</h4>
                </div>
            </div>
            <FormPermissions>
                <FormLoader />
            </FormPermissions>
        </>
    );
};

export default Component;
